import { render } from "./ButtonWidget.vue?vue&type=template&id=674dac61&scoped=true"
import script from "./ButtonWidget.vue?vue&type=script&lang=js"
export * from "./ButtonWidget.vue?vue&type=script&lang=js"

import "./ButtonWidget.vue?vue&type=style&index=0&id=674dac61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674dac61"]])

export default __exports__